// extracted by mini-css-extract-plugin
module.exports = {"newlineStringStyle":"DocumentPublishModal_newlineStringStyle_1qG6x","spinAround":"DocumentPublishModal_spinAround_n6eYM"};